import clx from 'classnames';
import React from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled from 'styled-components';

const FlexRowWrapper = styled.div<Pick<FlexRowProps, 'align'>>`
  display: flex;
  flex: 1 0 auto;
  min-width: 0;
  align-items: ${props => props.align ?? 'center'};
  &.responsive {
    flex-direction: column;
    > * {
      width: 100%;
      + * {
        margin-top: 12px;
      }
    }
    > .right {
      display: flex;
      justify-content: flex-end;
    }
  }
  /* align-items: center; */
`;
const FixedCol = styled.div<{ sx?: number; dx?: number }>`
  flex: 0 0 auto;
  min-width: 0;
  margin-left: ${props => props.sx ?? 0}px;
  margin-right: ${props => props.dx ?? 0}px;
`;
const FlexCol = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export interface FlexRowProps extends React.HTMLAttributes<HTMLDivElement> {
  left?: React.ReactNode;
  right?: React.ReactNode;
  gutter?: number;
  align?: 'center' | 'flex-start' | 'flex-end' | 'stretch';
  flexColClassName?: string;
  fixedColClassName?: string;
  /**
   * se attivo, la riga prenderà il 100% della larghezza in visualizzazione mobile
   */
  responsive?: boolean;
}

/**
 * Riga Flexibile con due colonne fisse e una colonna flexibile al centro
 * le colonne fisse sono opzionali
 */
export function FlexRow(props: FlexRowProps) {
  const {
    left,
    right,
    gutter: originalGutter,
    children,
    flexColClassName,
    fixedColClassName,
    responsive,
    ...rest
  } = props;
  const isMobile = useBreakpoint(down('sm'));

  const gutter = isMobile && responsive ? 0 : originalGutter;
  return (
    <FlexRowWrapper
      {...rest}
      className={clx(rest.className, { responsive: isMobile && responsive })}
    >
      {left && (
        <FixedCol className={clx(fixedColClassName, 'left')} dx={gutter}>
          {left}
        </FixedCol>
      )}
      <FlexCol className={clx(flexColClassName)}>{children}</FlexCol>
      {right && (
        <FixedCol className={clx(fixedColClassName, 'right')} sx={gutter}>
          {right}
        </FixedCol>
      )}
    </FlexRowWrapper>
  );
}
